import ImageModalCardHeader from './ImageModalCardHeader';



export default ImageModalCardHeader;
